import { createSelector } from 'reselect';

import { RootState } from 'store/types';

export const npv2TimeSlotsSelector = (state: RootState) => state.booking.appointment.npv2State;

export const npv2TimeSlotsDataSelector = createSelector(
  npv2TimeSlotsSelector,
  npv2State => npv2State.data
);

export const npv2SelectedProviderIdSelector = createSelector(
  npv2TimeSlotsSelector,
  npv2State => npv2State.npv2ProviderId
);

export const npv2SelectedProviderLocationSlotsSelector = createSelector(
  [npv2TimeSlotsDataSelector, npv2SelectedProviderIdSelector],
  (npv2TimeSlots, npv2ProviderId) => {
    return npv2TimeSlots[npv2ProviderId];
  }
);
